import React, { useState } from 'react';
import {
  Button, Checkbox, SelectionControlLabel, Typography, TextField
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { EmailFieldFormatter } from '../FieldFormatter/EmailFieldFormatter';
import constants from '../../constants/constants';
import {
  emailValidator,
  retrieveEmailPreferences,
  unsubscribeFromAllEmailSubscriptions
} from '../../common/sharedFunctions';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import { addAnalyticEvent } from '../../analytics/common';
import { confirmOverlay } from '../../analytics/email';

export const UnsubscriptionModal = ({
  handleClose,
  handleSuccess,
  handleError,
  searchedEmail,
}) => {
  const [optOutOfComm, setOptOutOfComm] = useState(false);
  const [emailIfMissing, setEmailIfMissing] = useState('');

  React.useEffect(() => {
    addAnalyticEvent(confirmOverlay);
  }, []);

  const handleDoNotCallClick = () => {
    const actualEmail = searchedEmail || emailIfMissing;

    retrieveEmailPreferences({
      emailAddress: actualEmail,
      callback: (retrieveResponse) => {
        unsubscribeFromAllEmailSubscriptions(
          actualEmail,
          (response) => {
            handleSuccess(actualEmail, response, retrieveResponse);
          },
          (err) => {
            handleError(err);
          }
        );
      },
      err: handleError
    });
  };

  const isEnabledDisabled = () => {
    return optOutOfComm && (searchedEmail || emailValidator(emailIfMissing));
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={handleClose}
    >
      <div className="sui-grid sui-gap-4 preferences-modal__content">
        <Typography variant="h4">Please Confirm Your Unsubscribe Request</Typography>
        <Typography variant="body-base">
          Please enter your e-mail to unsubscribe from all future promotional emails from
          The Home Depot.<br />To continue, please check the box below:
        </Typography>
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-12 sm:sui-col-span-10 md:sui-col-span-8 lg:sui-col-span-6 sui-grid sui-gap-4">
            {searchedEmail ? (
              <TextField
                header="Email Address"
                type="text"
                defaultValue={searchedEmail}
                value={searchedEmail}
                disabled
              />
            ) : (
              <EmailFieldFormatter callback={setEmailIfMissing} value={emailIfMissing} />
            )}
          </div>
        </div>
        <div>
          <Typography variant="body-xs">
            <SelectionControlLabel value="optOut" label={constants.DO_NOT_WANT_EMAILS}>
              <Checkbox
                formName="receiveEmailComm"
                aria-label="receiveEmailComm"
                id="receiveEmailComm"
                onChange={() => setOptOutOfComm(!optOutOfComm)}
                checked={optOutOfComm}
                value={optOutOfComm + ''}
              />
            </SelectionControlLabel>
          </Typography>
          <div className="sui-ml-6 sui-mt-4">
            <Typography variant="body-xs">
              {constants.TRANSACTIONAL_COMMUNICATION_DISCLAIMER}
            </Typography>
          </div>
        </div>
        <hr className="hr-line" />
        <div className="sui-grid sui-grid-cols-12">
          <div className="sui-col-span-8" />
          <div className="sui-col-span-4">
            <Button
              data-testid="doNotCallButton"
              onClick={handleDoNotCallClick}
              disabled={!isEnabledDisabled()}
              fullWidth
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </MobileAwareOverlay>
  );
};

UnsubscriptionModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSuccess: PropTypes.func.isRequired,
  handleError: PropTypes.func,
  searchedEmail: PropTypes.string,
};

UnsubscriptionModal.defaultProps = {
  searchedEmail: null,
  handleError: () => {},
};
